import { useReadonlyField } from 'components/common-form/contexts/readonly/FieldMetadataContext';
import { SummaryFieldRow } from 'components/common-form/sidePanel/docToolbar/summary/builder/node/SummaryFieldRow';
import { FormattedMessage } from 'components/shared/Intl';
import { IntlKey } from 'locales';
import { ClientReadonlyValueDefinition } from 'models/metadata/readonlyValue.definition';
import { FC } from 'react';

export interface ProductSummaryClientFieldProps {
  node: ClientReadonlyValueDefinition;
}

export const ProductSummaryClientField: FC<ProductSummaryClientFieldProps> = ({ node }) => {
  const data = useReadonlyField().getMetadataWithData(node);

  const translationKey = node.translationKey ?? node.id;

  return (
    <SummaryFieldRow labelKey={translationKey} id={node.id}>
      {data && (
        <p className="text-large fw-light m-0" data-e2e="product-summary-field-SelectedOnBehalfClient">
          <FormattedMessage id={data.label as IntlKey} defaultMessage={data.label} />
        </p>
      )}
    </SummaryFieldRow>
  );
};

ProductSummaryClientField.displayName = 'ProductSummaryClientField';
